import Cookies from 'js-cookie';
import mixpanel from 'mixpanel-browser';
import { Input, Select, MenuItem, Fab } from '@mui/material';

import { Income } from '../components/Elements/Income';
import { NetWorthTabInfo } from '../components/Elements/NetWorthTabInfo';

import {
  TEXT,
  INCOME_TEXT,
  ASSET_TEXT,
  LIABILITY_TEXT,
  NET_WORTH_TEXT,
  NET_WORTH_TEXT_ROW,
  TABS,
  NET_WORTH_ASSET_TEXT,
  NET_WORTH_LIABILITY_TEXT,
} from '../constants/Dashboard';

export const getOrSetAnonymousUserId = () => {
  let anonymousUserId = Cookies.get('anonymousUserId');

  if (!anonymousUserId) {
    anonymousUserId = mixpanel.get_distinct_id();
    Cookies.set('anonymousUserId', anonymousUserId, { expires: 30, path: '/' });
  }

  return anonymousUserId;
};

export const confirmPasswordCheck = ({ password, confirmPassword }) => {
  return password === confirmPassword;
};

export const arrayRange = (start, stop, step = 1) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, index) => start + index * step);

export const getTotalIncome = (val1, val2, val3) => {
  return Number(val1) + Number(val2) + Number(val3);
};

export const getFieldType = ({
  type,
  options = [],
  value = '',
  fieldEnumType = TEXT,
  textContent,
  onChange,
  incomeAmt = 0,
  helperText = '',
  name,
}) => {
  const fieldTypes = {
    select: (
      <Select id="form-field-helper" value={value} onChange={onChange}>
        {options.map(({ value, text }) => (
          <MenuItem key={value} value={value}>
            {text}
          </MenuItem>
        ))}
      </Select>
    ),
    input: (
      <>
        <Input
          id="form-field-helper"
          autoComplete="off"
          name={name}
          value={value}
          type={fieldEnumType}
          onChange={onChange}
          disableUnderline
        />{' '}
        {helperText && (
          <div style={{ margin: '5px', fontSize: '16px', color: '#727272' }}> {helperText} </div>
        )}{' '}
      </>
    ),
    [INCOME_TEXT]: <Income textContent={textContent} incomeAmt={incomeAmt} />,
    [TABS]: (
      <div className="residential-modal-tabs-wrapper">
        {options.map((tab) => {
          const selected = tab.value === value ? 'selected' : '';
          return (
            <Fab
              id="tabs-rent-or-own"
              key={tab.value}
              className={selected}
              onClick={() => {
                onChange({ target: { value: tab.value } });
              }}
              sx={{ borderRadius: 3, width: '32%', height: '50px' }}
            >
              {' '}
              {tab.text}{' '}
            </Fab>
          );
        })}
      </div>
    ),
    [ASSET_TEXT]: <Income textContent={textContent} incomeAmt={value} />,
    [LIABILITY_TEXT]: <Income textContent={textContent} incomeAmt={value} />,
    [NET_WORTH_ASSET_TEXT]: <NetWorthTabInfo incomeAmt={value} />,
    [NET_WORTH_LIABILITY_TEXT]: <NetWorthTabInfo incomeAmt={value} />,
    [NET_WORTH_TEXT]: <NetWorthTabInfo incomeAmt={value} />,
    [NET_WORTH_TEXT_ROW]: <Income textContent={textContent} incomeAmt={value} />,
  };

  return fieldTypes[type];
};

export const JOHN_DOE = 'John Doe';

export const getUserFullName = ({ firstname = '', lastname = '' }) => {
  if (!firstname && !lastname) {
    return JOHN_DOE;
  }
  return (
    firstname?.[0]?.toUpperCase() +
    firstname?.slice(1) +
    ' ' +
    lastname?.[0]?.toUpperCase() +
    lastname?.slice(1)
  );
};

export const isBot = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const botPatterns = [
    /bot/i,
    /spider/i,
    /crawl/i,
    /slurp/i,
    /facebookexternalhit/i,
    /mediapartners-google/i,
    /adsbot-google/i,
    /googlebot/i,
    /bingbot/i,
    /yandex/i,
    /duckduckbot/i,
  ];
  return botPatterns.some((pattern) => pattern.test(userAgent));
};

// <!-- Event snippet for Sign-up (1) conversion page
// In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->
{
  /* <script> */
}
export const gtag_report_conversion = (url) => {
  mixpanel.track('gtag_conversion', {
    url,
    tracked: process.env.REACT_APP_ENV === 'api',
  });

  if (process.env.REACT_APP_ENV !== 'api') {
    return;
  }
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url;
    }
  };
  window.gtag('event', 'conversion', {
    send_to: process.env.REACT_APP_GOOGLE_TAG_ID,
    event_callback: callback,
  });
  return false;
};
// </script>
